import React, { useEffect, useRef, useState } from 'react';
import styles from './CollapsableArea.module.scss';

export default function CollapsableArea({ className, expanded, children }) {
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const contentEl = contentRef.current;
        if (!contentEl) {
            return undefined;
        }

        const measure = () => {
            setContentHeight(contentEl.offsetHeight);
            setReady(true);
        };

        // Measure once immediately, then keep the height in sync with any
        // change to the content (children updating, fonts loading, images
        // resizing, etc.) so the area never gets stuck at a stale height.
        measure();

        let observer = null;
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(measure);
            observer.observe(contentEl);
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, []);

    return (
        <div
            className={[styles.CollapsableArea, className ?? '', ready ? styles.animated : null, expanded ? 'expanded' : 'collapsed'].join(' ')}
            style={{
                height: expanded ? (ready ? contentHeight : '') : 0,
            }}>
            <div ref={contentRef}>{children}</div>
        </div>
    );
}
